import Typography from "@mui/material/Typography"
import Stack from "@mui/material/Stack"
import { observer } from "mobx-react-lite/dist"
import { useProposalsEditRecipientsStore } from "./ProposalsEditRecipientsStore"
import SkeletonLoader from "reusable/mui/skeleton/SkeletonLoader"
import FileUploadWithProgress from "reusable/mui/file-uploads/FileUploadWithProgress"
import ButtonWithProgress from "reusable/mui/progress-button/ButtonWithProgress"

export default observer(function ProposalsEditRecipientsLogo() {
   const proposalsEditRecipientsStore = useProposalsEditRecipientsStore()

   return <SkeletonLoader loading={proposalsEditRecipientsStore.loader.isLoading}>
      <Typography variant="subtitle1" sx={{ flexGrow: 1, marginBottom: 3, fontWeight: 'bold' }}>Add your logo</Typography>
      {!proposalsEditRecipientsStore.proposal.step1?.logoFileName && <Stack sx={{ alignItems: 'end', marginBottom: .5 }}>
         <ButtonWithProgress
            variant="text"
            loading={proposalsEditRecipientsStore.logoLoader.isLoading}
            onClick={proposalsEditRecipientsStore.useAdvisorLogo}
            disabled={!proposalsEditRecipientsStore.advisorOrgLogoName}
         >Use logo from org settings</ButtonWithProgress>
      </Stack>}
      <FileUploadWithProgress
         files={proposalsEditRecipientsStore.fileUpload.file}
         subtext="JPG or PNG (max. 10MB)"
         getPresignedUrl={proposalsEditRecipientsStore.getUploadUrl}
         accept={{ "image/png": ['.png'], "image/jpeg": ['.jpeg'] }}
         onFilesValidated={proposalsEditRecipientsStore.onNewLogo}
         getUploadedFileUrl={proposalsEditRecipientsStore.getUploadedLogoUrl}
         onFileRemove={proposalsEditRecipientsStore.resetLogo}
         maxFiles={1}
      />
   </SkeletonLoader>
})
